import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import PersistancePlugin from './utils/persistance';

const elements = document.querySelectorAll('[data-app="calculator"]');

elements.forEach(element => {
	if (element.__vue_app__) {
		return;
	}

	const persistState = element.dataset.persistState !== undefined;
	const locale = element.dataset.locale || 'de';
	const isSummaryView = element.dataset.summaryView !== undefined;
	const initialData = element.dataset.initial ? JSON.parse(element.dataset.initial) : null;
	const returnLabel = element.dataset.returnLabel || null;
	const continueLabel = element.dataset.continueLabel || null;
	const ctaLabel = element.dataset.ctaLabel || null;
	const ctaTarget = element.dataset.ctaTarget || null;

	if (persistState) {
		PersistancePlugin(store);
	}

	App.beforeCreate = function () {
		this.$store.commit('setLocale', { locale });

		if (isSummaryView) {
			this.$store.commit('showSummary');
		}

		this.$store.commit('initialiseStore', { initialData });
		this.$store.commit('setResetEnabled', persistState);
		this.$store.commit('setCustomNavigation', {
			returnLabel,
			continueLabel,
			ctaLabel,
			ctaTarget
		});
	};

	createApp(App)
		.use(store)
		.use(router)
		.mixin({
			methods: {
				$t(key, replacements = {}) {
					let text = this.$store.state.i18n[key];

					for (const [key, value] of Object.entries(replacements)) {
						if (value !== undefined) {
							text = text.replace(new RegExp(`\\$\{${key}}`, 'g'), value);
						}
					}

					return text;
				},
				initCustomFormFields() {
					if (window.LN && window.LN.initCustomFields) {
						window.LN.initCustomFields(this.$el);
					}
				}
			}
		})
		.mount(element);
});
